<template>
  <div class="article-preview m-container-max">
    <lite-app-header v-if="isMideaConnect && !useDefaultHeader" :title="articleDetail.sName || articleDetail.title"
    :showRight="showRight"
    @shareAction="shareAction"
    ></lite-app-header>
    <div class="x-qrcode" v-if="isPC && !hiddenQRCode">
      <div class="qrcode-text">
        <span style="font-size: 16px;">美信扫码预览文章</span>
      </div>
      <div id="qrcode"></div>
    </div>
    <div v-show="!is_shield" class="main" :style="(isMideaConnect&&!useDefaultHeader)?'margin-top: 3rem;':''">
      <div class="card" style="height: 100vh;">
        <ContentTemplate :article-detail="articleDetail"></ContentTemplate>
      </div>
    </div>
  </div>
</template>

<script>
import ContentTemplate from '../components/ContentTemplate'
import { articleMixin } from '../mixins/article'
import LiteAppHeader from '../components/LiteAppHeader'
import QRCode from 'qrcodejs2'
import Vue from 'vue'
import { isPC, isMideaConnect } from '../utils/utils'
import { handleContentDetailResponse } from './handleNMCReponse'
export default {
  components: {
    ContentTemplate,
    LiteAppHeader
  },
  data () {
    return {
      articleDetail: { title: '', createDataTime: '', author: '' },
      token: '',
      isPC: isPC(),
      showRight: false, // 是否展示右边分享标识
      is_shield: false // 是否屏蔽了资讯
    }
  },
  mixins: [articleMixin],
  computed: {
    isMideaConnect () {
      // return true
      return isMideaConnect()
    },
    hiddenQRCode () {
      return this.$route.query.hiddenQRCode && this.$route.query.hiddenQRCode === '1'
    },
    useDefaultHeader () {
      return this.$route.query.defaultHeader && this.$route.query.defaultHeader === '1'
    }
  },
  methods: {
    initQRcode () {
      const qrCode = new QRCode('qrcode', {
        width: 130,
        height: 130,
        text: window.location.href,
        colorDark: '#000',
        colorLight: '#fff'
      })
      console.log(qrCode)
    },
    getArticle () {
      this.$store.dispatch('getContentPreview', { id: this.articleId }).then(res => {
        if (res.data.data) {
          this.showRight = (res.data.data?.shareRange > 0)
        }
        if (res.data.data.msgType === 2 && res.data.data.categoryCode !== 'Live') {
          window.location.replace(res.data.data.contentUrl)
        }
        this.$store.dispatch('getRichText', { contentUrl: res.data.data.contentUrl }).then(content => {
          res.data.data.content = content.data
          const data = handleContentDetailResponse(res.data, null)
          console.log('lzb data', data)
          this.handleArticleData(data)
          if (this.$route.query.hiddenQRCode && this.$route.query.hiddenQRCode === '1') {
            // 2021-08-18更新，调用另一个能增加文章阅读量的接口（如果url有hiddenQRCode标志）
            this.newContentReadAdd()
          }
          this.weixinShare()
        })
      })
        .catch(err => {
          /* eslint-disable */
          if (String(err).indexOf(`'contentUrl' of null`) > -1) {
            this.$toastMessage({ icon: '&#xe69f;', message1: `${this.$t('lang.contentAddressNotFound')}` })
          } else {
            window.alert(err)
          }
          /* eslint-disable */
        })

      // this.$store.dispatch('getContentDetail', { id: '1379349258195775490' })
      //   .then(data => {
      //     return data
      //     // this.handleArticleData(data)
      //     // this.handleArticleData(data)
      //   })
    },
    // 新的已读接口
    newContentReadAdd () {
      const identification = this.$route.query.identification
      this.$store.dispatch('addReadedMxpOther',
        {
          materialId: this.articleId,
          ssoToken: identification === 'admin' && this.$route.query.token,
          identification: identification,
          isThirdPartPlat: identification === 'admin' ? this.$route.query.isThirdPartPlat : !isMideaConnect(),
          appKey: this.$route.query.appKey
        }).then(readRes => {
        console.log(readRes)
        // if (readRes && (readRes.data.code !== 0)) {
        //   this.$toastMessage({ icon: '&#xe69f;', message1: `调用已读接口失败，原因:${readRes.data.msg}` })
        // }
      })
    },
    getArticleOfAddReadedNum () {
      const language = this.$i18n.locale
      let locale = 'zh_CN'
      if (language === 'en') {
        locale = 'en_US'
      } else if (language === 'ja') {
        locale = 'ja_JP'
      } else {
        locale = 'zh_CN'
      }
      this.$store.dispatch('getContentDetail', { id: this.articleId, locale: locale, type: '2' }).then(res => {
        console.log('contentPreview----', res)
        if (res.data.data) {
          this.showRight = (res.data.data?.shareRange > 0)
        }
        if (res.data.data.msgType === 2 && res.data.data.categoryCode !== 'Live') {
          window.location.replace(res.data.data.contentUrl)
        }
        this.$store.dispatch('getRichText', { contentUrl: res.data.data.contentUrl }).then(content => {
          res.data.data.content = content.data
          const data = handleContentDetailResponse(res.data, null)
          console.log(data)
          this.handleArticleData(data)
          this.newContentReadAdd()
        })
      })
        .catch(err => {
          /* eslint-disable */
          if (String(err).indexOf(`'contentUrl' of null`) > -1) {
            this.$toastMessage({ icon: '&#xe69f;', message1: `${this.$t('lang.contentAddressNotFound')}` })
          } else {
            window.alert(err)
          }
          /* eslint-disable */
        })
    },
    validateParams () {
      this.articleId = this.$route.query.id || this.$route.params.id
      return !(typeof (this.$route.query.id || this.$route.params.id) === 'undefined')
    },
    //分享操作
    async shareAction(){
      /**
       * title           分享标题
       * subTitle         分享子标题
       * action           openH5 或 openUrl
       * widgetId         H5模块id
       * widgetExtra     扩展参数
       * url             url地址
       * imageUrl         图片地址
       * actionType       1-分享 2-红包 3-网盘 4-红包通知 5-分享图片 6-分享小程序(目前只有项目分支支持)
       * shareRange       0-美信和其它都不分享 1-只分享到美信 2-分享到美信和其它 3-分享其他,不分享美信,(项目分支包涵qq空间，美的分支没有) 4-分享其他和美信，不显示第二列 5-分享微信和微信朋友圈 6-只显示分享到微信朋友
       * sharePageTitle   服务号希望ActionBar 一直显示服务号名称
       * sid             服务号id
       **/
      let url = window.location.href
      const shareObj = {
        title: this.articleDetail.title,
        subTitle: this.articleDetail.description,
        action: 'openUrl',
        widgetId: '',
        widgetExtra: '',
        imageUrl: this.articleDetail.coverImg,
        actionType: 1,
        shareRange: this.articleDetail.shareRange,
        url:url,
        sharePageTitle:'',
        sid: ''
      }
      if (window.cordova) {
        cordova.exec(function () {
        }, function () {
        }, 'MideaCommon', 'showShare', [shareObj])
      }
    },
    weixinShare () {
      const self = this
      if (window.isWxTagLaunch) {
        window.wx.ready(function () {
          wx.onMenuShareAppMessage({
            title: self.articleDetail.title,
            link: window.location.href,
            imgUrl: self.articleDetail.coverImg,
            desc: self.articleDetail.summary,
            success: function () {
              console.log('share app message success!!!')
            }
          })
          window.wx.onMenuShareTimeline({
            title: self.articleDetail.title,
            link: window.location.href,
            imgUrl: self.articleDetail.coverImg,
            success: function () {
              console.log('share timeline success!!!')
            }
          })
        })
      }
    }
  },
  created () {
    if (this.validateParams()) {
      const result = {
        data: {/* global CONFIG */
          baseUrl: CONFIG.baseUrl
        }
      }
      Vue.prototype.$baseUrl = result.data.baseUrl
      
      if (this.isPC && !(this.$route.query.hiddenQRCode &&
        this.$route.query.hiddenQRCode === '1')) {
        this.getArticle()
        // 2021-08-18更新，调用另一个能增加文章阅读量的接口（如果url有hiddenQRCode标志）
      } else {
        this.getArticleOfAddReadedNum()
      }
    }
  },
  mounted () {
    if (this.isPC && !(this.$route.query.hiddenQRCode &&
      this.$route.query.hiddenQRCode === '1')) {
      this.initQRcode()
      // 2021-08-18更新，调用另一个能增加文章阅读量的接口（如果url有hiddenQRCode标志）
    }
  }
}
</script>

<style scoped>
  .x-qrcode {
    position: fixed;
    top: 9.375rem;
    right: 1.25rem;
    bottom: 0;
    z-index: 10005;
  }
  .qrcode-text {
    border: 1px solid #333;
    text-align: center;
    margin-bottom: .3125rem;
  }
</style>
